import { render, staticRenderFns } from "./NoteDisplay.vue?vue&type=template&id=3a630fe6"
import script from "./NoteDisplay.vue?vue&type=script&lang=ts"
export * from "./NoteDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports